<label class="checkbox-container">
    <input type="radio" name="radio" [checked] ="checked" [value]="value" (change)="returnValue()">
    <span class="checkmark"></span>
  </label>